import { render, staticRenderFns } from "./PasswordResetSendAfter.vue?vue&type=template&id=3e05224b&scoped=true&"
import script from "./PasswordResetSendAfter.vue?vue&type=script&lang=js&"
export * from "./PasswordResetSendAfter.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetSendAfter.vue?vue&type=style&index=0&id=3e05224b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e05224b",
  null
  
)

export default component.exports